import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import logo from '../images/nav-logo.png';
import LanguageSwitcher from "./LanguageSwitcher";
import translations from "./translations";
import { useLanguage } from "./Context/LanguageContext";



function Navbar() {
  const { language } = useLanguage();
  const [isLogged, setIsLogged] = useState('');
  const [navState, setNavState] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const isHomePage = location.pathname === '/' || location.pathname === '/Home';


  



  function hideNav() {
    setNavState(false);
  }

  function showNav() {
    setNavState(true);
  }

  function handleNavItemClick() {
    hideNav();
  }

  return (
    <>

      <nav className="navbar navbar-expand-lg bg-light fixed-top">
        <div className="container">
          <Link to="/">
            <a className="navbar-brand" href="#">
              <img src={logo} alt="" srcSet="" />
            </a>
          </Link>
          <button
            onClick={showNav}
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className={`collapse navbar-collapse ${navState ? 'show' : ''}`} id="navbarSupportedContent">
            <ul className="navbar-nav  mb-2 mb-lg-0" onClick={handleNavItemClick}>
              <li className="nav-item">
                <Link className="nav-link" to="/" onClick={hideNav}>
                {translations[language].navItemHome}
                </Link>
              </li>
              
                <>
                  <li className="nav-item" onClick={hideNav}>
                    <Link className="nav-link" to="/about-us">
                    {translations[language].navItemAbout}
                    </Link>
                  </li>
                  {/* <li className="nav-item" onClick={hideNav}>
                    <a className="nav-link" href="#contact">
                    {translations[language].navItemContact}
                    </a>
                  </li> */}
                </>
              
              <li className="nav-item" onClick={hideNav}>
                <Link className="nav-link" to="/Products">
                {translations[language].navItemProducts}
                </Link>
              </li>
              {/* <li className="nav-item" onClick={hideNav}>
                <Link className="nav-link" to="/ScientificArticles">
                {translations[language].navItemBlogs}
                </Link>
              </li> */}
              <li className="nav-item" onClick={hideNav}>
                <Link className="nav-link" to="/OurRepresentative">
                {translations[language].navItemOurRep}
                </Link>
              </li>
            </ul>


          </div>
            <LanguageSwitcher className='language-btn-desktop'/>
        </div>
      </nav>
    </>
  );
}

export default Navbar;